import { Flex, VStack, HStack, Text, Popover, PopoverContent, PopoverTrigger, Box } from '@cad-arc';
import { useMemo } from 'react';
import { PillUnit } from '@mark43/cad-api';
import { UNITS_PILL_TRUNCATE_COUNT } from './constants';
import { UnitPill } from '../common/components/unit-pill';

export function FrEventUnitPills({ units = [] }: { units?: PillUnit[] }) {
    const { displayedUnits, truncateUnits } = useMemo(() => {
        const displayedUnits: PillUnit[] = [];
        const truncateUnits: PillUnit[] = [];

        for (let index = 0; index < units.length; index++) {
            const pillUnit = units[index];

            if (index < UNITS_PILL_TRUNCATE_COUNT) {
                displayedUnits.push(pillUnit);
            } else {
                truncateUnits.push(pillUnit);
            }
        }

        return { displayedUnits, truncateUnits };
    }, [units]);

    return (
        <Flex alignItems="center" gap="5px" data-testid="assigned-unit-pills">
            {displayedUnits?.map((unit) => (
                <UnitPill key={unit?.id} unit={unit} />
            ))}
            {truncateUnits.length > 0 && (
                <Popover>
                    <PopoverTrigger onClick={(event) => event.stopPropagation()}>
                        <Text
                            color="brand"
                            style={{ cursor: 'pointer', textDecoration: 'underline' }}
                        >
                            +{truncateUnits.length}
                        </Text>
                    </PopoverTrigger>
                    <PopoverContent align="end" style={{ maxHeight: '60vh', overflowY: 'scroll' }}>
                        <VStack alignItems="start" gap={1}>
                            {truncateUnits.map((unit) => (
                                <HStack key={unit?.id} justifyContent="flex-start">
                                    <UnitPill unit={unit} />
                                    {!!unit?.tip && <Box as="span">{unit.tip}</Box>}
                                </HStack>
                            ))}
                        </VStack>
                    </PopoverContent>
                </Popover>
            )}
        </Flex>
    );
}
